
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/the-culture-map",
      function () {
        return require("private-next-pages/books/the-culture-map.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/the-culture-map"])
      });
    }
  